/**
 * Shared ReactQuill toolbar and formats for email body editing (admin + composer).
 */
/** Pixel sizes — must match Quill `attributors/style/size` whitelist. */
export const DEFAULT_EMAIL_RICH_TEXT_TOOLBAR = [
  [{ size: ["10px", false, "18px", "32px"] }],
  ["bold", "italic", "underline"],
  [{ list: "ordered" }, { list: "bullet" }],
  [{ color: [] }],
  ["link"],
  ["clean"],
];

export const DEFAULT_EMAIL_RICH_TEXT_FORMATS = [
  "size",
  "bold",
  "italic",
  "underline",
  "list",
  "bullet",
  "color",
  "link",
];
